/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { PieChartData } from '../../../charts/models/PieChartData';

@Component({
  selector: 'app-ctv-platform-distribution',
  templateUrl: './ctv-platform-distribution.component.html',
  styleUrls: ['./ctv-platform-distribution.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvPlatformDistributionComponent implements OnChanges {
  @Input() data: any;
  pieChartData: Array<PieChartData>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      if (this?.data?.platformDistribution) {
        this?.data?.platformDistribution?.map(item => {
          return {
            category: item?.deviceMarketingName,
            value: item?.totalTrafficRatio,
            title: item?.deviceMarketingName
          };
        });
      }
    }
  }
}
